// src/utils/uuid.js
export function uuidv4() {
  // Only rely on window; no 'self', no 'globalThis'
  const g = (typeof window !== 'undefined') ? window : {};

  // 1) Native
  if (g.crypto && typeof g.crypto.randomUUID === 'function') {
    return g.crypto.randomUUID();
  }

  // 2) Web Crypto (RFC4122 v4)
  if (g.crypto && typeof g.crypto.getRandomValues === 'function') {
    const buf = new Uint8Array(16);
    g.crypto.getRandomValues(buf);
    buf[6] = (buf[6] & 0x0f) | 0x40; // version
    buf[8] = (buf[8] & 0x3f) | 0x80; // variant
    const hex = Array.from(buf, b => b.toString(16).padStart(2, '0'));
    return `${hex.slice(0,4).join('')}-${hex.slice(4,6).join('')}-${hex.slice(6,8).join('')}-${hex.slice(8,10).join('')}-${hex.slice(10).join('')}`;
  }

  // 3) Fallback (non-crypto)
  return `id-${Date.now().toString(36)}-${Math.random().toString(36).slice(2,10)}`;
}
